<template>
  <header v-if="isLoggedIn" class="header" :class="{ 'is-notice': isNotice || isNoticeInquiry }">
    <a :href="hrefLink" class="nav-logo"></a>
    <a :href="survivalLink" class="survival-logo" target="_blank"></a>
    <a :href="levelsLink" class="levels-logo"></a>

    <Slide width="250" right :closeOnNavigation="true" noOverlay>
      <div class="menu-text">Menu</div>
      <router-link :to="{ name: 'notice'}"><span class="navigation"><template v-if="isNotice"><span :style="{ color : isNotice ? 'red' : 'black' }"><i class="fas fa-bell"></i>&nbsp;&nbsp;{{ $t('notice.title') }}</span></template><template v-else>{{ $t('notice.title') }}</template> <i class="fas fa-chevron-right"></i></span></router-link>
      <router-link :to="{ name: 'profile'}"><span class="navigation">{{ $t('profile.title') }} <i class="fas fa-chevron-right"></i></span></router-link>
      <router-link :to="{ name: 'inquiry'}"><span class="navigation"><template v-if="isNoticeInquiry"><span :style="{ color : isNoticeInquiry ? 'red' : 'black' }"><i class="fas fa-bell"></i>&nbsp;&nbsp;{{ $t('inquiry.title') }}</span></template><template v-else>{{ $t('inquiry.title') }}</template> <i class="fas fa-chevron-right"></i></span></router-link>
      <router-link :to="{ name: 'levels'}"><span class="navigation">{{ $t('level.title') }} <i class="fas fa-chevron-right"></i></span></router-link>

      <a @click.prevent="logout" class="router-link-active"><span class="navigation navigation-logout">{{ $t('logout.title') }} <i class="fas fa-chevron-right"></i></span></a>

    </Slide>
    <logoutmodal v-show="logout_modal" @close="close"></logoutmodal>
  </header>
  
  <header v-else class="header">
    <a href="/" class="nav-logo"></a>
  </header>  
</template>

<script>
  import {appName, api} from '../../config';
  import {mapGetters} from 'vuex';

  import { Slide } from 'vue-burger-menu'
  
  import LogoutModal from '../login/LogoutModal.vue'

  export default {
    data() {
      return {
        appName: appName,
        logout_modal: false,
        currentYear: (new Date).getFullYear()
      }
    },
    components: {
      Slide,
      'logoutmodal': LogoutModal,
    },
    created() {
      this.logout_modal = false
    },
    
    computed: {
      isNotice() {
        if (this.$route.name == 'login') {
          return false
        } else {
          let unreadList = this.$store.getters.unreadnews.filter(item => {
            return ('type' in item.data && item.data.type == 'news')
          })
          
          return unreadList.length > 0 ? true : false
        }
      },
      isNoticeInquiry() {
        if (this.$route.name == 'login') {
          return false
        } else {
          let unreadList = this.$store.getters.unreadnews.filter(item => {
            return ('type' in item.data && item.data.type == 'inquiry')
          })
          return unreadList.length > 0 ? true : false
        }
      },
      isLoggedIn() {
        const authUser = this.$store.getters.getAuthUser;
        if(authUser) {
          return true;
        } else {
          return false;
        }
      },
      userLevel() {
        return this.$store.getters.level;
      },
      hrefLink() {
        if(this.$store.getters.useLevel) {
          return '/apps/top/' + this.$store.getters.useLevel.toLowerCase()
        } else {
          if((this.$store.getters.level.toLowerCase() != "n4" && this.$store.getters.level.toLowerCase() != "n5")) {
            if (this.$route.name == 'top') {
              return '/apps'
            } else {
              if(this.$store.getters.section_data && this.$store.getters.section_data.level) {
                if(this.$store.getters.section_data.level == "N4" || this.$store.getters.section_data.level == "N5") {
                  return '/apps/top/n4'
                } else {
                  if(this.$store.getters.level.toLowerCase() == "n2") {
                    
                    if(this.$store.getters.section_data.level == "N3") {
                      return '/apps/top/n3'
                    } else {
                      return '/apps'
                    }
                    
                  } else if(this.$store.getters.level.toLowerCase() == "n2") {
                    
                    if(this.$store.getters.section_data.level == "N3") {
                      return '/apps/top/n2'
                    } else {
                      return '/apps'
                    }
                    
                  } else {
                    return '/apps'
                  }
                }
              } else {
                return '/apps/top/n4'
              }
            }
          } else {
            if (this.$route.name == 'top') {
              return '/apps'
            } else {
              return '/apps'
            }
          }
        }
      },
      survivalLink() {
        return window.global.jsl_survival_url + '/apps'
      },
      levelsLink() {
        return '/apps/levels'
      }
    },
    
    methods: {
      logout() {
        this.logout_modal = true;
      },
      close() {
        this.logout_modal = false;
      }
    },
  }
</script>
<style lang="scss">


</style>
